import React from "react";
import { default as WButton } from "@mui/material/Button";

function Button(props) {
  return <WButton {...props} />;
}

export default Button;
